/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const JiraRequestPost = {
  id: 'jira-request.post',
  tag: 'Support',
  summary: 'Create Jira request',
  description: 'Create Jira Request',
  method: 'post',
  flags: { isAuthorized: true },
  route: () => `/jira/request`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            requestTypeId: z.string(),
            requestFieldValues: z.record(z.string(), z.unknown()),
            clusterId: z.string().optional(),
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.any(),
        },
      },
    },
  },
} as const satisfies Endpoint;
